import React from 'react';
import styled from 'styled-components';
import { Users } from 'lucide-react';

const Chip = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: var(--surface-light);
  border: 1px solid var(--border-color);
  border-radius: 20px;
  font-size: 12px;
  color: var(--text-secondary);
`;

const IconWrapper = styled.span`
  display: flex;
  align-items: center;
  color: var(--primary-color);
`;

// כל הצוות רואה את כל הלקוחות (הנראות נפתחה בבקנד) — הצ'יפ אחיד.
const ClientRoleIndicatorChip: React.FC = () => {
  return (
    <Chip>
      <IconWrapper><Users size={14} /></IconWrapper>
      כל הלקוחות
    </Chip>
  );
};

export default ClientRoleIndicatorChip;
